var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05684 1.5711C5.94182 1.41488 5.71951 1.37454 5.55557 1.4887C5.39935 1.60457 5.35901 1.82602 5.47317 1.98997C5.75299 2.37622 5.90062 2.83714 5.90062 3.32124C5.90062 3.8062 5.75299 4.26627 5.47317 4.65252C5.35901 4.80874 5.39163 5.03877 5.55557 5.15379C5.62166 5.20271 5.69548 5.21988 5.76071 5.21988C5.868 5.21988 5.98302 5.17009 6.04911 5.07224C6.4182 4.56239 6.61561 3.95383 6.61561 3.32124C6.6242 2.68865 6.42678 2.08867 6.05684 1.5711Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96901 0.634372C6.84541 0.478155 6.62396 0.454122 6.46775 0.576863C6.31153 0.700464 6.2875 0.921914 6.41024 1.07813C6.92781 1.71931 7.19905 2.49181 7.19905 3.31323C7.19905 4.13552 6.92781 4.90802 6.41024 5.54833C6.2875 5.70455 6.31153 5.92686 6.46775 6.0496C6.53384 6.09938 6.61538 6.132 6.69005 6.132C6.79649 6.132 6.8952 6.08222 6.96901 5.99982C7.57671 5.24448 7.91404 4.29087 7.91404 3.31323C7.91404 2.33559 7.57671 1.39829 6.96901 0.634372Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54488 0.0256336C4.45476 -0.0155665 4.35605 -0.00698312 4.27365 0.0505253L1.80851 1.91569H0.362221C0.222313 1.91569 0.108154 2.0307 0.108154 2.17061V4.47095C0.108154 4.61085 0.222313 4.72587 0.362221 4.72587H1.80851L4.28223 6.59103C4.32343 6.62365 4.38094 6.64081 4.43845 6.64081C4.47965 6.64081 4.51227 6.63223 4.55347 6.61592C4.64359 6.57472 4.69252 6.4846 4.69252 6.38589V0.255667C4.69252 0.156959 4.63501 0.0668336 4.54488 0.0256336Z",
    fill: "#F0F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.3f55f34a142a205e95a740cb7854d1f1.svg";
export { ForwardRef as ReactComponent };